"use client";

import { TObituaryBookItem } from "@/types/obituary";
import { scrollToElement } from "@/utils/scroll";
import { useState } from "react";
import AddReplyForm from "./AddReplyForm";
import CommentReplies from "./CommentReplies";
import ImageComment from "./ImageComment";
import UserText from "./UserText";
import { dateIsoToLocaleString } from "@/utils/date";

type Props = {
  loadBook: () => void;
};

const Comment = (props: TObituaryBookItem & Props) => {
  const [replyMode, setReplyMode] = useState<boolean>(false);
  const enableReply = () => setReplyMode(true);
  const disableReply = () => setReplyMode(false);
  let { image, name, timestamp, message, replies, loadBook } = props;
  return (
    <div
      id={props.uuid}
      className="flex w-full max-w-3xl flex-col border border-secondary-200 bg-secondary-100/50"
    >
      {image && <ImageComment {...image} />}
      <div className="flex flex-col gap-1 p-3 md:p-6">
        <UserText as="p" className="text-2xl font-semibold text-secondary" value={name} />
        <p className="text-xs text-secondary-400">
          {dateIsoToLocaleString(timestamp)}
        </p>
        <UserText className="text-lg" value={message} />
        {replyMode && (
          <AddReplyForm
            slug={props.slug}
            commentId={props.uuid}
            loadBook={loadBook}
            disableReply={disableReply}
          />
        )}
        {replies && <CommentReplies {...props} />}
        {!replyMode && (
          <div className="flex h-auto w-full justify-end pt-4">
            <button
              onClick={() => {
                enableReply();
                scrollToElement(props.uuid);
              }}
              className="btn secondary solid small"
            >
              Antworten
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Comment;
